import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Nav from './Nav';
import Footer from './Footer';
import { usePageEffects } from '../../hooks/usePageEffects';

/** Layout del sito pubblico: navbar + contenuto + footer, con le animazioni di pagina. */
const PublicLayout: React.FC = () => {
  const location = useLocation();
  usePageEffects(location.pathname);
  const heroTransparent = location.pathname === '/';

  return (
    <>
      <Nav transparent={heroTransparent} />
      <main><Outlet /></main>
      <Footer />
    </>
  );
};

export default PublicLayout;
